document.addEventListener('DOMContentLoaded', function () {
    let cardGroups, groupActions;

    function initCardGroups() {
        cardGroups = document.querySelectorAll('.cta-cards');
        groupActions = [];

        cardGroups.forEach(group => {
            const cards = group.querySelectorAll('.expandable-card');
            if (!cards.length) return;

            function setUniformHeightForCards() {
                if (window.innerWidth >= 992) {
                    cards.forEach(card => {
                        card.style.height = 'auto';
                        card.style.maxHeight = '';
                    });

                    const rows = {};
                    cards.forEach(card => {
                        const top = card.offsetTop;
                        if (!rows[top]) rows[top] = [];
                        rows[top].push(card);
                    });

                    Object.values(rows).forEach(rowCards => {
                        let maxHeight = 0;
                        rowCards.forEach(card => {
                            maxHeight = Math.max(maxHeight, card.offsetHeight);
                        });
                        rowCards.forEach(card => {
                            card.style.height = maxHeight + 'px';
                        });
                    });
                } else {
                    cards.forEach(card => {
                        card.style.height = '';
                    });
                }
            }

            function updateCardMaxHeight(card) {
                if (window.innerWidth <= 991) {
                    card.style.maxHeight = 'none';
                    card.style.maxHeight = card.scrollHeight + 'px';
                } else {
                    card.style.maxHeight = '';
                }
            }

            // FULL RESET: collapse all cards
            cards.forEach(card => {
                card.classList.remove('expanded');
                card.classList.add('collapsed');
                card.style.maxHeight = '';
                card.style.height = 'auto';
            });

            // Equalise heights while all are collapsed
            setUniformHeightForCards();

            // Expand first card visually
            cards[0].classList.remove('collapsed');
            cards[0].classList.add('expanded');
            if (window.innerWidth <= 991) {
                updateCardMaxHeight(cards[0]);
            }

            // Click to expand
            cards.forEach(card => {
                card.addEventListener('click', function () {
                    cards.forEach(c => {
                        c.classList.remove('expanded');
                        c.classList.add('collapsed');
                        c.style.maxHeight = '';
                    });

                    this.classList.remove('collapsed');
                    this.classList.add('expanded');

                    if (window.innerWidth <= 991) {
                        updateCardMaxHeight(this);
                        
                        // Wait for collapse/expand animations to complete before scrolling
                        setTimeout(() => {
                            const cardPosition = this.offsetTop;
                            
                            // Get the closest parent that has a position other than static
                            let offsetParent = this.offsetParent;
                            let additionalOffset = 0;
                            while (offsetParent) {
                                additionalOffset += offsetParent.offsetTop;
                                offsetParent = offsetParent.offsetParent;
                            }

                            window.scrollTo({
                                top: cardPosition + additionalOffset - 90,
                                behavior: 'smooth'
                            });
                        }, 150); // Increased timeout to allow animations to complete
                    }
                    // Desktop: don't change heights after load
                });
            });

            // Store re‑equalise action (mobile heights)
            groupActions.push(function () {
                if (window.innerWidth <= 991) {
                    cards.forEach(card => {
                        card.style.height = '';
                        if (card.classList.contains('expanded')) {
                            updateCardMaxHeight(card);
                        } else {
                            card.style.maxHeight = '';
                        }
                    });
                }
                setUniformHeightForCards();
            });
        });
    }

    function resetHeightsOnly() {
        cardGroups.forEach(group => {
            const cards = group.querySelectorAll('.expandable-card');
            if (!cards.length) return;

            function setUniformHeightForCards() {
                if (window.innerWidth >= 992) {
                    cards.forEach(card => {
                        card.style.height = 'auto';
                        card.style.maxHeight = '';
                    });

                    const rows = {};
                    cards.forEach(card => {
                        const top = card.offsetTop;
                        if (!rows[top]) rows[top] = [];
                        rows[top].push(card);
                    });

                    Object.values(rows).forEach(rowCards => {
                        let maxHeight = 0;
                        rowCards.forEach(card => {
                            maxHeight = Math.max(maxHeight, card.offsetHeight);
                        });
                        rowCards.forEach(card => {
                            card.style.height = maxHeight + 'px';
                        });
                    });
                } else {
                    cards.forEach(card => {
                        card.style.height = '';
                    });
                }
            }

            function updateCardMaxHeight(card) {
                if (window.innerWidth <= 991) {
                    card.style.maxHeight = 'none';
                    card.style.maxHeight = card.scrollHeight + 'px';
                } else {
                    card.style.maxHeight = '';
                }
            }

            // Reset card heights but keep expanded/collapsed classes
            cards.forEach(card => {
                card.style.maxHeight = '';
                card.style.height = 'auto';
            });

            const expandedCard = Array.from(cards).find(card => card.classList.contains('expanded'));

            if (expandedCard) {
                if (window.innerWidth <= 991) {
                    updateCardMaxHeight(expandedCard);
                }
            }

            setUniformHeightForCards();
        });
    }

    // Initial call on DOM ready
    initCardGroups();

    // Call again after all assets load
    window.addEventListener('load', function () {
        setTimeout(() => {
            initCardGroups();
        }, 25);
    });

    // On resize, just reset heights but keep expanded cards unchanged
    window.addEventListener('resize', function () {
        resetHeightsOnly();
    });
});
